class AirportUIModel {
  constructor({
    airportCode,
    fliesToAirportCode,
  }) {
    this.code = airportCode;
    this.fliesTo = fliesToAirportCode || [];
  }
}

export default AirportUIModel;
